// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { api_url } from "../config/config";

// const BlogPage = () => {
//   const [blogs,   setBlogs]   = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search,  setSearch]  = useState("");

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     axios
//       .get(`${api_url}/blog`)
//       .then((res) => setBlogs(Array.isArray(res.data?.data) ? res.data.data : []))
//       .catch((err) => console.error("Error fetching blogs:", err))
//       .finally(() => setLoading(false));
//   }, []);

//   const formatDate = (d) =>
//     new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });

//   const plusPattern = `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`;

//   /* all blogs shown in the grid — including index 0 */
//   const filteredBlogs = blogs.filter((b) =>
//     !search ||
//     b.title?.toLowerCase().includes(search.toLowerCase()) ||
//     b.author?.toLowerCase().includes(search.toLowerCase())
//   );
//   const bestBlogs = blogs.slice(0, 5);

//   /* ── Skeleton ── */
//   const SkeletonCard = () => (
//     <div className="bg-white rounded-2xl border border-[#e2eaea] overflow-hidden animate-pulse flex flex-col">
//       <div className="h-60 bg-[#e2eaea]" />
//       <div className="p-4 flex flex-col gap-2">
//         <div className="h-3 w-20 bg-[#e2eaea] rounded-full" />
//         <div className="h-4 w-3/4 bg-[#e2eaea] rounded-full" />
//         <div className="h-3 w-full bg-[#e2eaea] rounded-full" />
//       </div>
//     </div>
//   );

//   /* ── Magazine card — title overlaid on image ── */
//   const MagazineCard = ({ blog, i = 0 }) => (
//     <Link
//       to={`/blogs/${blog.slug}`}
//       className="group relative rounded-2xl overflow-hidden shadow-[0_4px_18px_rgba(22,44,42,0.12)] hover:shadow-[0_10px_36px_rgba(22,44,42,0.22)] hover:-translate-y-1.5 transition-all duration-300 flex flex-col bg-[#1e4a46]"
//       style={{ animation: `fadeInUp 0.4s ease ${i * 70}ms both` }}
//     >
//       {/* Full image — h-60 for extra height */}
//       <div className="relative h-60 overflow-hidden flex-shrink-0">
//         <img
//           src={blog.blog_images?.[0]?.image_url}
//           alt={blog.title}
//           className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
//           onError={(e) => { e.target.onerror = null; e.target.src = "/default.svg"; }}
//         />
//         {/* Strong gradient so overlaid text is readable */}
//         <div className="absolute inset-0 bg-gradient-to-t from-[#0a1715]/92 via-[#0a1715]/35 to-transparent" />

//         {/* Hover top accent bar */}
//         <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#ff601e] via-[#5fbdb3] to-[#ff601e] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

//         {/* Type badge */}
//         {blog.blog_type?.name && (
//           <span className="absolute top-3 left-3 bg-[#ff601e] text-white text-[9px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wide shadow-[0_2px_8px_rgba(255,96,30,0.45)]">
//             {blog.blog_type.name}
//           </span>
//         )}

//         {/* Title + author + date — overlaid at bottom of image */}
//         <div className="absolute bottom-0 left-0 right-0 p-4">
//           <div className="flex items-center gap-1.5 mb-2">
//             <div className="w-5 h-5 rounded-full bg-[#5fbdb3]/30 border border-[#5fbdb3]/40 flex items-center justify-center flex-shrink-0">
//               <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
//                 <circle cx="12" cy="7" r="4"/>
//               </svg>
//             </div>
//             <p className="text-[10px] font-semibold text-[#5fbdb3] truncate">{blog.author}</p>
//             <span className="text-white/30 text-[10px]">·</span>
//             <p className="text-[10px] text-white/55">{formatDate(blog.published_at)}</p>
//           </div>
//           <h3 className="font-bold text-[13px] sm:text-[14px] text-white leading-snug line-clamp-2 group-hover:text-[#5fbdb3] transition-colors duration-200">
//             {blog.title}
//           </h3>
//         </div>
//       </div>

//       {/* Slim white footer strip */}
//       <div className="px-4 py-2.5 bg-white flex items-center justify-between border-t border-[#f1f5f5]">
//         {blog.content ? (
//           <span className="text-[10px] text-[#8faba9]">
//             {Math.max(1, Math.ceil(blog.content.length / 200))} min read
//           </span>
//         ) : <span />}
//         <span className="flex items-center gap-0.5 text-[11px] font-bold text-[#1e4a46] group-hover:text-[#ff601e] transition-colors ml-auto">
//           Read article
//           <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//             <path d="M5 12h14M12 5l7 7-7 7"/>
//           </svg>
//         </span>
//       </div>
//     </Link>
//   );

//   /* ── Best sidebar card ── */
//   const BestCard = ({ blog, index }) => (
//     <Link
//       to={`/blogs/${blog.slug}`}
//       className="group flex items-center gap-3 bg-white border border-[#e2eaea] rounded-2xl p-3 hover:shadow-[0_4px_18px_rgba(22,44,42,0.12)] hover:border-[#5fbdb3] transition-all duration-200 hover:-translate-y-0.5"
//     >
//       <span className="flex-shrink-0 w-7 h-7 rounded-xl bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center font-bold text-[12px] text-[#1e4a46] group-hover:bg-[#1e4a46] group-hover:text-white transition-colors">
//         {String(index + 1).padStart(2, "0")}
//       </span>
//       <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0">
//         <img
//           src={blog.blog_images?.[0]?.image_url}
//           alt={blog.title}
//           className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//           onError={(e) => { e.target.onerror = null; e.target.src = "/default.svg"; }}
//         />
//       </div>
//       <div className="flex-1 min-w-0">
//         <p className="font-bold text-[12px] text-[#1e4a46] line-clamp-2 leading-snug group-hover:text-[#ff601e] transition-colors">
//           {blog.title}
//         </p>
//         <p className="text-[10px] text-[#8faba9] mt-0.5">{formatDate(blog.published_at)}</p>
//       </div>
//     </Link>
//   );

//   return (
//     <div className="min-h-screen bg-[#f8fafa] font-poppins">

//       {/* ══════════════════════════════════════════
//           HERO BANNER — text + search only
//       ══════════════════════════════════════════ */}
//       <div
//         className="relative w-full overflow-hidden"
//         style={{ background: "linear-gradient(135deg, #0a1715 0%, #162c2a 50%, #1e4a46 100%)" }}
//       >
//         <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
//           style={{ backgroundImage: plusPattern, backgroundRepeat: "repeat", backgroundSize: "40px 40px" }} />
//         <div className="absolute -top-16 right-0 w-96 h-96 rounded-full bg-[#5fbdb3]/10 blur-3xl pointer-events-none" />
//         <div className="absolute bottom-0 left-1/4 w-64 h-64 rounded-full bg-[#ff601e]/8 blur-3xl pointer-events-none" />

//         <div className="relative px-5 sm:px-8 lg:px-14 py-10 sm:py-14">
//           <div className="flex items-center gap-3 mb-3">
//             <span className="w-6 h-[2px] bg-[#ff601e] rounded-full" />
//             <span className="text-[11px] font-semibold uppercase tracking-widest text-[#5fbdb3]">
//               Health &amp; Wellness Blog
//             </span>
//           </div>
//           <h1 className="font-bold text-[26px] sm:text-[38px] lg:text-[46px] text-white leading-tight mb-3 max-w-[560px]">
//             A Guide to <span className="text-[#5fbdb3]">Staying Healthy</span>
//           </h1>
//           <p className="text-[13px] text-white/50 leading-relaxed max-w-[420px] mb-6">
//             Expert tips from healthcare professionals — modern practices, preventive care, and trustworthy health information.
//           </p>

//           {/* Search + stats in one row */}
//           <div className="flex flex-col sm:flex-row sm:items-center gap-4">
//             {/* Search */}
//             <div className="flex items-center gap-2 bg-white/[0.09] border border-white/[0.15] rounded-xl px-4 h-11 w-full sm:max-w-[340px] focus-within:bg-white/[0.13] focus-within:border-[#5fbdb3]/60 transition-all duration-200">
//               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0">
//                 <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
//               </svg>
//               <input
//                 type="text"
//                 placeholder="Search articles…"
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//                 className="flex-1 bg-transparent outline-none text-[13px] text-white placeholder-white/35"
//               />
//               {search && (
//                 <button onClick={() => setSearch("")} className="text-white/40 hover:text-white text-lg leading-none">×</button>
//               )}
//             </div>

//             {/* Stats with bordered SVG icons */}
//             <div className="flex items-center gap-3 flex-wrap">
//               {/* Articles */}
//               <div className="flex items-center gap-2.5 bg-white/[0.07] border border-white/[0.12] rounded-xl px-3.5 py-2.5">
//                 <div className="w-8 h-8 rounded-lg border border-[#5fbdb3]/40 bg-[#5fbdb3]/10 flex items-center justify-center flex-shrink-0">
//                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
//                     <polyline points="14 2 14 8 20 8"/>
//                     <line x1="16" y1="13" x2="8" y2="13"/>
//                     <line x1="16" y1="17" x2="8" y2="17"/>
//                     <polyline points="10 9 9 9 8 9"/>
//                   </svg>
//                 </div>
//                 <div>
//                   <p className="font-bold text-[15px] text-white leading-none">{loading ? "—" : `${blogs.length}+`}</p>
//                   <p className="text-[10px] text-white/40 mt-0.5">Articles</p>
//                 </div>
//               </div>

//               {/* Health Topics */}
//               <div className="flex items-center gap-2.5 bg-white/[0.07] border border-white/[0.12] rounded-xl px-3.5 py-2.5">
//                 <div className="w-8 h-8 rounded-lg border border-[#ff601e]/40 bg-[#ff601e]/10 flex items-center justify-center flex-shrink-0">
//                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ff601e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
//                   </svg>
//                 </div>
//                 <div>
//                   <p className="font-bold text-[15px] text-white leading-none">15+</p>
//                   <p className="text-[10px] text-white/40 mt-0.5">Health Topics</p>
//                 </div>
//               </div>

//               {/* Expert Authors */}
//               <div className="flex items-center gap-2.5 bg-white/[0.07] border border-white/[0.12] rounded-xl px-3.5 py-2.5">
//                 <div className="w-8 h-8 rounded-lg border border-white/20 bg-white/[0.08] flex items-center justify-center flex-shrink-0">
//                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
//                     <circle cx="9" cy="7" r="4"/>
//                     <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
//                     <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
//                   </svg>
//                 </div>
//                 <div>
//                   <p className="font-bold text-[15px] text-white leading-none">5+</p>
//                   <p className="text-[10px] text-white/40 mt-0.5">Expert Authors</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-[#f8fafa] to-transparent" />
//       </div>

//       {/* ══════════════════════════════════════════
//           CONTENT — 4-col grid + sidebar
//       ══════════════════════════════════════════ */}
//       <div className="px-5 sm:px-8 lg:px-14 py-10">
//         <div className="flex flex-col xl:flex-row gap-10">

//           {/* Main grid */}
//           <div className="flex-1 min-w-0">
//             <div className="flex items-center gap-4 mb-6">
//               <span className="w-5 h-[2px] bg-[#ff601e] rounded-full" />
//               <h2 className="font-bold text-[18px] sm:text-[20px] text-[#1e4a46]">
//                 {search ? `Results for "${search}"` : "All Articles"}
//               </h2>
//               <div className="flex-1 h-px bg-[#e2eaea]" />
//               {!loading && (
//                 <span className="text-[12px] font-medium text-[#8faba9] bg-[#eaf4f3] border border-[#d4ecea] rounded-full px-3 py-1">
//                   {filteredBlogs.length} article{filteredBlogs.length !== 1 ? "s" : ""}
//                 </span>
//               )}
//             </div>

//             {/* 4 in one row */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
//               {loading
//                 ? Array.from({ length: 8 }).map((_, i) => <SkeletonCard key={i} />)
//                 : filteredBlogs.length > 0
//                   ? filteredBlogs.map((blog, i) => <MagazineCard key={blog.id} blog={blog} i={i} />)
//                   : (
//                     <div className="col-span-full flex flex-col items-center justify-center py-16 gap-3">
//                       <p className="text-[15px] font-semibold text-[#374747]">No articles found</p>
//                       <button onClick={() => setSearch("")} className="text-[13px] text-[#1e4a46] font-semibold hover:text-[#ff601e] transition-colors">
//                         Clear search
//                       </button>
//                     </div>
//                   )
//               }
//             </div>

//             {!loading && blogs.length === 0 && (
//               <div className="flex flex-col items-center justify-center py-20 gap-4">
//                 <div className="w-16 h-16 rounded-2xl bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center">
//                   <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
//                     <polyline points="14 2 14 8 20 8"/>
//                   </svg>
//                 </div>
//                 <p className="text-[15px] font-semibold text-[#374747]">No blog posts yet</p>
//                 <p className="text-[13px] text-[#8faba9]">Check back soon for health tips and guides.</p>
//               </div>
//             )}
//           </div>

//           {/* Best articles sidebar */}
//           {(loading || bestBlogs.length > 0) && (
//             <div className="xl:w-[280px] flex-shrink-0">
//               <div className="bg-white border border-[#e2eaea] rounded-2xl shadow-[0_2px_12px_rgba(22,44,42,0.07)] overflow-hidden sticky top-[160px]">
//                 <div
//                   className="px-5 py-4 relative overflow-hidden"
//                   style={{ background: "linear-gradient(135deg, #162c2a 0%, #1e4a46 100%)" }}
//                 >
//                   <div className="absolute inset-0 opacity-[0.05] pointer-events-none"
//                     style={{ backgroundImage: plusPattern, backgroundRepeat: "repeat", backgroundSize: "40px 40px" }} />
//                   <div className="relative flex items-center gap-2">
//                     <span className="text-[15px]">⭐</span>
//                     <h3 className="font-bold text-[15px] text-white">Best Articles</h3>
//                   </div>
//                   <p className="relative text-[11px] text-white/45 mt-0.5">Top picks from our blog</p>
//                 </div>

//                 <div className="p-4 flex flex-col gap-3">
//                   {loading
//                     ? Array.from({ length: 5 }).map((_, i) => (
//                         <div key={i} className="flex items-center gap-3 animate-pulse">
//                           <div className="w-7 h-7 rounded-xl bg-[#e2eaea] flex-shrink-0" />
//                           <div className="w-12 h-12 rounded-xl bg-[#e2eaea] flex-shrink-0" />
//                           <div className="flex-1 flex flex-col gap-1.5">
//                             <div className="h-3 bg-[#e2eaea] rounded-full w-3/4" />
//                             <div className="h-2 bg-[#e2eaea] rounded-full w-1/2" />
//                           </div>
//                         </div>
//                       ))
//                     : bestBlogs.map((blog, i) => <BestCard key={blog.id} blog={blog} index={i} />)
//                   }
//                 </div>

//                 <div className="px-4 pb-4">
//                   <div className="bg-[#eaf4f3] border border-[#d4ecea] rounded-xl p-3 text-center">
//                     <p className="text-[11px] text-[#607d7b] font-medium">
//                       🌿 Weekly wellness tips from our experts
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       <style>{`
//         @keyframes fadeInUp {
//           from { opacity: 0; transform: translateY(24px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default BlogPage;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { api_url } from "../config/config";

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
    const filteredBlogs = blogs.filter((b) =>
    !search ||
    b.title?.toLowerCase().includes(search.toLowerCase()) ||
    b.author?.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${api_url}/blog`)
      .then((res) => {
        setBlogs(Array.isArray(res.data?.data) ? res.data.data : []);
      })
      .catch((err) => console.error("Error fetching blogs:", err))
      .finally(() => setLoading(false));
  }, []);

  const formatDate = (d) =>
    new Date(d).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  const plusPattern = `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`;

  /* ── Skeleton ── */
  const SkeletonCard = () => (
    <div className="bg-white rounded-2xl border border-[#e2eaea] overflow-hidden animate-pulse flex flex-col">
      <div className="h-44 bg-[#e2eaea]" />
      <div className="p-4 flex flex-col gap-2.5">
        <div className="h-2.5 w-20 bg-[#e2eaea] rounded-full" />
        <div className="h-4 w-3/4 bg-[#e2eaea] rounded-full" />
        <div className="h-3 w-full bg-[#e2eaea] rounded-full" />
        <div className="h-3 w-2/3 bg-[#e2eaea] rounded-full" />
      </div>
    </div>
  );

  /* ── Blog card ── */
  const BlogCard = ({ blog, delay = 0 }) => (
    <Link
      to={`/blogs/${blog.slug}`}
      className="group bg-white border border-[#e2eaea] rounded-2xl overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.07)] hover:shadow-[0_10px_32px_rgba(22,44,42,0.16)] hover:border-[#5fbdb3] hover:-translate-y-1.5 transition-all duration-300 flex flex-col"
      style={{ animationDelay: `${delay}ms` }}
    >
      {/* Image */}
      <div className="relative h-44 overflow-hidden flex-shrink-0">
        <img
          src={blog.blog_images?.[0]?.image_url}
          alt={blog.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/default.svg";
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a1715]/55 via-transparent to-transparent" />

        {/* Top accent line on hover */}
        <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#162c2a] via-[#5fbdb3] to-[#ff601e] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        {blog.blog_type?.name && (
          <span className="absolute top-2.5 left-2.5 bg-[#ff601e] text-white text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide shadow-[0_2px_6px_rgba(255,96,30,0.4)]">
            {blog.blog_type.name}
          </span>
        )}
        <div className="absolute bottom-2.5 right-2.5 flex items-center gap-1 bg-[#0a1715]/70 backdrop-blur-sm rounded-lg px-2 py-0.5">
          <svg
            width="8"
            height="8"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#5fbdb3"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
          <span className="text-[9px] font-medium text-white/80">
            {formatDate(blog.published_at)}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 flex flex-col gap-2 flex-1">
        <div className="flex items-center gap-1.5">
          <div className="w-5 h-5 rounded-full bg-[#1e4a46] flex items-center justify-center flex-shrink-0">
            <svg
              width="9"
              height="9"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </div>
          <p className="text-[10px] font-semibold text-[#5fbdb3] truncate">
            {blog.author}
          </p>
        </div>

        <h3 className="font-bold text-[13px] sm:text-[14px] text-[#1e4a46] leading-snug group-hover:text-[#ff601e] transition-colors duration-200 line-clamp-2">
          {blog.title}
        </h3>

        {blog.subtitle && (
          <p className="text-[11px] text-[#607d7b] line-clamp-2 leading-relaxed flex-1">
            {blog.subtitle}
          </p>
        )}

        <div className="w-full h-px bg-[#f1f5f5] mt-1" />

        <div className="flex items-center justify-between">
          {blog.content && (
            <span className="text-[10px] text-[#8faba9]">
              {Math.max(1, Math.ceil(blog.content.length / 200))} min read
            </span>
          )}
          <span className="flex items-center gap-0.5 text-[11px] font-bold text-[#1e4a46] group-hover:text-[#ff601e] transition-colors ml-auto">
            Read
            <svg
              width="10"
              height="10"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </span>
        </div>
      </div>
    </Link>
  );

  /* ── "Best of" highlight card (horizontal) ── */
  const BestCard = ({ blog, index }) => (
    <Link
      to={`/blogs/${blog.slug}`}
      className="group flex items-center gap-4 bg-white border border-[#e2eaea] rounded-2xl p-3 shadow-[0_2px_10px_rgba(22,44,42,0.06)] hover:shadow-[0_6px_22px_rgba(22,44,42,0.14)] hover:border-[#5fbdb3] transition-all duration-300 hover:-translate-y-0.5"
    >
      {/* Rank number */}
      <span className="flex-shrink-0 w-8 h-8 rounded-xl bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center font-bold text-[13px] text-[#1e4a46] group-hover:bg-[#1e4a46] group-hover:text-white transition-colors duration-200">
        {String(index + 1).padStart(2, "0")}
      </span>
      {/* Thumbnail */}
      <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0 border border-[#e2eaea]">
        <img
          src={blog.blog_images?.[0]?.image_url}
          alt={blog.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/default.svg";
          }}
        />
      </div>
      {/* Text */}
      <div className="flex-1 min-w-0">
        <p className="font-bold text-[12px] sm:text-[13px] text-[#1e4a46] leading-snug line-clamp-2 group-hover:text-[#ff601e] transition-colors">
          {blog.title}
        </p>
        <p className="text-[10px] text-[#8faba9] mt-0.5">
          {formatDate(blog.published_at)}
        </p>
      </div>
    </Link>
  );

  const bestBlogs = blogs.slice(0, 5);
  const allBlogs = blogs;

  return (
    <div className="min-h-screen bg-[#f8fafa] font-poppins">
      {/* ══════════════════════════════════════════════
          HERO BANNER — text only, no image
      ══════════════════════════════════════════════ */}
      <div
        className="relative w-full overflow-hidden"
        style={{
          background:
            "linear-gradient(135deg, #0a1715 0%, #162c2a 50%, #1e4a46 100%)",
        }}
      >
        <div
          className="absolute inset-0 opacity-[0.04] pointer-events-none"
          style={{
            backgroundImage: plusPattern,
            backgroundRepeat: "repeat",
            backgroundSize: "40px 40px",
          }}
        />
        <div className="absolute -top-16 right-0 w-96 h-96 rounded-full bg-[#5fbdb3]/10 blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-1/4 w-64 h-64 rounded-full bg-[#ff601e]/8 blur-3xl pointer-events-none" />

        <div className="relative px-5 sm:px-8 lg:px-14 py-10 sm:py-14">
          <div className="flex items-center gap-3 mb-3">
            <span className="w-6 h-[2px] bg-[#ff601e] rounded-full" />
            <span className="text-[11px] font-semibold uppercase tracking-widest text-[#5fbdb3]">
              Health &amp; Wellness Blog
            </span>
          </div>
          <h1 className="font-bold text-[26px] sm:text-[38px] lg:text-[46px] text-white leading-tight mb-3 max-w-[560px]">
            A Guide to <span className="text-[#5fbdb3]">Staying Healthy</span>
          </h1>
          <p className="text-[13px] text-white/50 leading-relaxed max-w-[420px] mb-6">
            Expert tips from healthcare professionals — modern practices,
            preventive care, and trustworthy health information.
          </p>

          {/* Search + stats in one row */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
            {/* Search */}
            <div className="flex items-center gap-2 bg-white/[0.09] border border-white/[0.15] rounded-xl px-4 h-11 w-full sm:max-w-[340px] focus-within:bg-white/[0.13] focus-within:border-[#5fbdb3]/60 transition-all duration-200">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#5fbdb3"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="flex-shrink-0"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input
                type="text"
                placeholder="Search articles…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="flex-1 bg-transparent outline-none text-[13px] text-white placeholder-white/35"
              />
              {search && (
                <button
                  onClick={() => setSearch("")}
                  className="text-white/40 hover:text-white text-lg leading-none"
                >
                  ×
                </button>
              )}
            </div>

            {/* Stats with bordered SVG icons */}
            <div className="flex items-center gap-3 flex-wrap">
              {/* Articles */}
              <div className="flex items-center gap-2.5 bg-white/[0.07] border border-white/[0.12] rounded-xl px-3.5 py-2.5">
                <div className="w-8 h-8 rounded-lg border border-[#5fbdb3]/40 bg-[#5fbdb3]/10 flex items-center justify-center flex-shrink-0">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#5fbdb3"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                    <polyline points="10 9 9 9 8 9" />
                  </svg>
                </div>
                <div>
                  <p className="font-bold text-[15px] text-white leading-none">
                    {loading ? "—" : `${blogs.length}+`}
                  </p>
                  <p className="text-[10px] text-white/40 mt-0.5">Articles</p>
                </div>
              </div>

              {/* Health Topics */}
              <div className="flex items-center gap-2.5 bg-white/[0.07] border border-white/[0.12] rounded-xl px-3.5 py-2.5">
                <div className="w-8 h-8 rounded-lg border border-[#ff601e]/40 bg-[#ff601e]/10 flex items-center justify-center flex-shrink-0">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ff601e"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                  </svg>
                </div>
                <div>
                  <p className="font-bold text-[15px] text-white leading-none">
                    15+
                  </p>
                  <p className="text-[10px] text-white/40 mt-0.5">
                    Health Topics
                  </p>
                </div>
              </div>

              {/* Expert Authors */}
              <div className="flex items-center gap-2.5 bg-white/[0.07] border border-white/[0.12] rounded-xl px-3.5 py-2.5">
                <div className="w-8 h-8 rounded-lg border border-white/20 bg-white/[0.08] flex items-center justify-center flex-shrink-0">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                </div>
                <div>
                  <p className="font-bold text-[15px] text-white leading-none">
                    5+
                  </p>
                  <p className="text-[10px] text-white/40 mt-0.5">
                    Expert Authors
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-[#f8fafa] to-transparent" />
      </div>

      <div className="px-5 sm:px-8 lg:px-14 py-10">
        {/* ══════════════════════════════════════════════
            BEST BLOGS + ALL BLOGS — 2 column layout
        ══════════════════════════════════════════════ */}
        <div className="flex flex-col xl:flex-row gap-10">
          {/* ── Main: All blogs 4-col grid ── */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-4 mb-6">
              <span className="w-5 h-[2px] bg-[#ff601e] rounded-full" />
              <h2 className="font-bold text-[18px] sm:text-[20px] text-[#1e4a46]">
                {search ? `Results for "${search}"` : "All Articles"}
              </h2>
              <div className="flex-1 h-px bg-[#e2eaea]" />
              {!loading && (
                <span className="text-[12px] font-medium text-[#8faba9] bg-[#eaf4f3] border border-[#d4ecea] rounded-full px-3 py-1">
                  {filteredBlogs.length} article{filteredBlogs.length !== 1 ? "s" : ""}
                </span>
              )}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {loading
                ? Array.from({ length: 8 }).map((_, i) => (
                    <SkeletonCard key={i} />
                  ))
                : allBlogs.map((blog, i) => (
                    <BlogCard key={blog.id} blog={blog} delay={i * 60} />
                  ))}
            </div>

            {/* Empty state */}
            {!loading && blogs.length === 0 && (
              <div className="flex flex-col items-center justify-center py-20 gap-4">
                <div className="w-16 h-16 rounded-2xl bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#5fbdb3"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                  </svg>
                </div>
                <p className="text-[15px] font-semibold text-[#374747]">
                  No blog posts yet
                </p>
                <p className="text-[13px] text-[#8faba9]">
                  Check back soon for health tips and guides.
                </p>
              </div>
            )}
          </div>

          {/* ── Sidebar: Best blogs ── */}
          {(loading || bestBlogs.length > 0) && (
            <div className="xl:w-[300px] flex-shrink-0">
              {/* Best blogs card */}
              <div className="bg-white border border-[#e2eaea] rounded-2xl shadow-[0_2px_12px_rgba(22,44,42,0.07)] overflow-hidden sticky top-[160px]">
                {/* Header */}
                <div
                  className="px-5 py-4 relative overflow-hidden"
                  style={{
                    background:
                      "linear-gradient(135deg, #162c2a 0%, #1e4a46 100%)",
                  }}
                >
                  <div
                    className="absolute inset-0 opacity-[0.06] pointer-events-none"
                    style={{
                      backgroundImage: plusPattern,
                      backgroundRepeat: "repeat",
                      backgroundSize: "40px 40px",
                    }}
                  />
                  <div className="relative flex items-center gap-2">
                    <span className="text-[16px]">⭐</span>
                    <h3 className="font-bold text-[15px] text-white">
                      Best Articles
                    </h3>
                  </div>
                  <p className="relative text-[11px] text-white/45 mt-0.5">
                    Top picks from our wellness blog
                  </p>
                </div>

                {/* List */}
                <div className="p-4 flex flex-col gap-3">
                  {loading
                    ? Array.from({ length: 5 }).map((_, i) => (
                        <div
                          key={i}
                          className="flex items-center gap-3 animate-pulse"
                        >
                          <div className="w-8 h-8 rounded-xl bg-[#e2eaea] flex-shrink-0" />
                          <div className="w-14 h-14 rounded-xl bg-[#e2eaea] flex-shrink-0" />
                          <div className="flex-1 flex flex-col gap-1.5">
                            <div className="h-3 bg-[#e2eaea] rounded-full w-3/4" />
                            <div className="h-2.5 bg-[#e2eaea] rounded-full w-1/2" />
                          </div>
                        </div>
                      ))
                    : bestBlogs.map((blog, i) => (
                        <BestCard key={blog.id} blog={blog} index={i} />
                      ))}
                </div>

                {/* CTA */}
                <div className="px-4 pb-4">
                  <div className="bg-[#eaf4f3] border border-[#d4ecea] rounded-xl p-3 text-center">
                    <p className="text-[11px] text-[#607d7b] font-medium leading-relaxed">
                      🌿 Stay healthy with our weekly wellness tips
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ── Inline animation styles ── */}
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .grid > a {
          animation: fadeInUp 0.4s ease both;
        }
      `}</style>
    </div>
  );
};

export default BlogPage;
